import axios from "../../http/axios";
import {
    CLEAR_SELECTED_COUNTRY,
    COUNTRIES_FETCH_SUCCESSFULLY,
    COUNTRY_STATISTICS_FETCH_SUCCESSFULLY,
    COUNTRY_TIMELINE_LOAD,
    COUNTRY_TIMELINE_LOAD_SUCCESS,
    COVERED_COUNTRIES_FETCH_SUCESSFULLY,
    OPPONENT_COUNTRY_STATISTICS_FETCH_SUCCESSFULLY,
    COUNTRIES_ATC_PERCENTAGES_FETCH
} from "./actionTypes";

export const getCoveredCountries = () => dispatch => {
    axios.get("/country/covered")
        .then(data => {
            dispatch({type: COVERED_COUNTRIES_FETCH_SUCESSFULLY, payload: data.data})
        })
};

export const getStatisticsForCountry = (countryCode) => dispatch => {
    axios.get(`country/statistics/${countryCode}`)
        .then(data => {
            dispatch({type: COUNTRY_STATISTICS_FETCH_SUCCESSFULLY, payload: data.data})
        })
};

export const getStatisticsForOpponentCountry = countryCode => dispatch => {
    axios.get(`country/statistics/${countryCode}`)
        .then(data => {
            dispatch({type: OPPONENT_COUNTRY_STATISTICS_FETCH_SUCCESSFULLY, payload: data.data})
        })
};

export const clearCountrySelection = () => dispatch => {
    dispatch({type: CLEAR_SELECTED_COUNTRY});
};

export const loadCountryTimeline = (name) => dispatch => {
    dispatch({type: COUNTRY_TIMELINE_LOAD});
    axios.get(`/country/statistics/${name}`)
        .then(response => {
            dispatch({type: COUNTRY_TIMELINE_LOAD_SUCCESS, payload: response.data});
        });
};

export const loadCountries = () => dispatch => {
    axios.get("/country/covered")
        .then(response => {
            dispatch({type: COUNTRIES_FETCH_SUCCESSFULLY, payload: response.data});
        });
};

export const getCountryStats = () => dispatch => {
    axios.get("/drugs/global-drug-statistics-atc-percentages")
        .then(response => {
            let grouper = new Map();
            response.data.forEach(it => {
                let k = it.countryCode;
                let v = [it.atcGroup, it.percentage];
                let target = grouper.get(k);
                if(!target){
                    grouper.set(k, [v])
                } else {
                    target.push(v)
                }
            })
            dispatch({
                type: COUNTRIES_ATC_PERCENTAGES_FETCH,
                payload: grouper
            })
        })
}
